interface Props {
  isLongScan: boolean;
  includeEmailNote?: boolean;
}

/**
 * Shown while a paid full-site scan is running (up to 15 min).
 * Free instant audits must never show this banner.
 */
export function ScanInProgressBanner({ isLongScan, includeEmailNote = true }: Props) {
  if (!isLongScan) {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-brand-green/30 bg-brand-green/5 px-4 py-3 text-sm text-brand-ink">
        <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-brand-green border-t-transparent flex-shrink-0" />
        <span>We&apos;re scanning your site — this usually takes under a minute. Results will appear automatically.</span>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3 rounded-lg border border-brand-green/30 bg-brand-green/5 px-4 py-3 text-sm text-brand-ink">
      <span className="mt-0.5 inline-block h-3 w-3 flex-shrink-0 animate-spin rounded-full border-2 border-brand-green border-t-transparent" />
      <span>
        We&apos;re running a full scan of your site. This can take up to{' '}
        <strong>15 minutes</strong> — you can safely leave this page and check back.
        {includeEmailNote && (
          <> We&apos;ll email you when your results are ready.</>
        )}
      </span>
    </div>
  );
}
